module.exports = "/img/automatic-message.svg?8c48734340a07883a15cd096e99303d0";